import baseRequest from './baseRequest';

export const getMismatches = ({ page, limit, mismatchType }) => {
    const params = { page: page + 1, limit };
    if (mismatchType) {
        params.mismatchType = mismatchType;
    }
    return baseRequest(
        '/ops/digitisation/mismatches',
        'GET',
        params,
        null,
    );
};

export const decideMismatch = (mismatchId, decision, correctedValue = null) => {
    const data = {
        decision,
        ...(correctedValue !== null && correctedValue !== '' ? { correctedValue } : {}),
    };
    return baseRequest(
        `/ops/digitisation/mismatches/${mismatchId}/decide`,
        'POST',
        null,
        data,
    );
};
